import PropTypes from 'prop-types';
import { Toggle } from 'cat-ecommerce-alloy';
import { useDispatch } from 'react-redux';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import styles from '@app/components/pages/checkout/shopping-cart/styles.module.scss';
import { clearLineItemNotesFocus } from '@app/store/orders/actions';

const AvailabilityToggle = ({
  showAvailabilityBySource,
  displayAvailabityAndSourcingDetails,
  setTogglePrefs
}) => {
  const [t] = useTranslation();
  const dispatch = useDispatch();

  return (
    <Toggle
      id="showAvailabilityAndSourcingDetails"
      data-testid="showAvailabilityAndSourcingDetails"
      className={cx(
        'u-color--DarkGray px-2 d-print-none',
        styles['shopping-cart-page__toggle']
      )}
      label={
        showAvailabilityBySource
          ? t('AVAIL_STANDARD_AVAILAIBILITY_DATES')
          : t('AVAIL_STANDARD_AVAILABILITY_SOURCE')
      }
      labelClassName="d-flex align-items-end"
      checked={displayAvailabityAndSourcingDetails}
      setChecked={checked => {
        setTogglePrefs(checked);
        dispatch(clearLineItemNotesFocus());
      }}
      placement="start"
    />
  );
};

AvailabilityToggle.propTypes = {
  showAvailabilityBySource: PropTypes.bool,
  displayAvailabityAndSourcingDetails: PropTypes.bool,
  setTogglePrefs: PropTypes.func
};

export default AvailabilityToggle;
